import etmcCartEvent from './etmc-cart-event';

export default etmcCartEvent;
